function calculatePrecision({ max, min }: { max: number; min: number }): number {
  const range = max - min
  if (range < 0.1) return 3 // thousandths (0.001)
  if (range < 1) return 2 // hundredths (0.1)
  if (range < 10) return 1 // tenths (0.1)
  return 0 // ones (1)
}

export function createLinearBreaks({ min, max }: { min: number; max: number }, n: number) {
  const precision = calculatePrecision({ max, min })

  const range = Number((max - min).toFixed(precision))
  const increment = range / (n - 1)
  return Array.from({ length: n }, (_, i) => Number((min + i * increment).toFixed(precision)))
}
